import React, { useEffect, useMemo, useReducer, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Grid,
  Button,
  Typography,
  TextField,
  IconButton,
  Stack,
  Alert,
} from "@mui/material";
import { get, orderBy } from "lodash";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import T from "utils/constants/T";
import CashDDialog from "components/common/CashDDialog";
import { useFormik } from "formik";
import * as Yup from "yup";
import MainCard from "components/MainCard";
import CashDAutocomplete from "components/common/CashDAutocomplete";
import { fetchCompanies } from "store/reducers/dashboardSearch";
import { fetchCompanyDetails } from "store/reducers/companyTabDetails";
import ViewEmployerList from "./ViewEmployerList";
import { PAGINATION } from "utils/constants/pagination";
import { getEmployersList, inviteEmployer } from "store/reducers/employer";
import { WarningFilled } from "@ant-design/icons";

const ViewGroupSetting = () => {
  const dispatch = useDispatch();

  const { companyName } = useSelector((state: any) => state.companyTabData);
  let { companiesList } = useSelector((state: any) => state.dashboardSearch);
  const employerListData = useSelector((state : any) => state.employerListData);
  const { employers, page, pageSize, totalRecords, totalPages, isLoading: isEmployersLoading } =
  employerListData;
  console.log(employers,"DATA")
  const { INITIAL_PAGE, ROWS_PER_PAGE } = PAGINATION;
  const { isCashDSuperAdmin, isEmployerAdmin } = useSelector(
    (state: any) => state.auth
  );

  const [isModalOpen, setIsModalOpen] = useState(false);

  const selectedCompany = useSelector(
    (state: any) => state.dashboardSearch.selectedCompany,
    shallowEqual
  );

  const selectedCompanyId = useMemo(
    () => get(selectedCompany, "_id", ""),
    [selectedCompany]
  );
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePageChange = (page: number) => {
    setLocalState({ pageNumber: page });

    dispatch(
      getEmployersList(
        page,
        rowsPerPage,
        selectedCompanyId
      )
    );
    document.getElementsByClassName("MuiTableContainer-root")[0].scrollTop = 0;
  };

  const handleRowsPerPageChange = (event: any) => {
    const { value } = event.target;
    setLocalState({ pageNumber: INITIAL_PAGE, rowsPerPage: value });
    dispatch(
      getEmployersList(
        INITIAL_PAGE,
        value,
        selectedCompanyId
      )
    );
  };

  useEffect(() => {
    if (!selectedCompanyId) return;
      dispatch(fetchCompanyDetails(selectedCompanyId));

    dispatch(getEmployersList(INITIAL_PAGE, ROWS_PER_PAGE, selectedCompanyId));

    if (!isCashDSuperAdmin && selectedCompany) {
    formik.setFieldValue("companyName", selectedCompany.company_name);
    setLocalState({ searchInput: selectedCompany });
    }
  }, [
    dispatch,
    INITIAL_PAGE,
    ROWS_PER_PAGE,
    selectedCompany,
    selectedCompanyId,
    isCashDSuperAdmin,
  ]);



  const validationSchema = Yup.object({
    firstName: Yup.string()
      .matches(/^[A-Za-z\s]+$/, "Name must be alphabetic")
      .required("Name is a required field"),
    lastName: Yup.string()
      .matches(/^[A-Za-z\s]+$/, "Name must be alphabetic")
      .required("Name is a required field"),
    email: Yup.string()
      .email("Please enter a valid email")
      .required("Email is a required field"),
    companyName: Yup.string()
      .matches(/^[A-Za-z0-9\s&.,'-]+$/, "Company name must be valid")
      .required("Company is a required field"),
    employerRole: Yup.string().required("Role is a required field"),
  });

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      companyName: "",
      employerRole: "",
      email: "",
    },
    validationSchema,
    onSubmit: async (payload, { setTouched, resetForm }) => {
      await setTouched({
        firstName: true,
        lastName: true,
        email: true,
        companyName: true,
        employerRole: true,
      });
      const roleMap: Record<string, string> = {
        [T.EMPLOYER_ADMIN]: T.EMPLOYER,
        [T.EMPLOYER_USER]: T.MANAGER,
        [T.PAYROLL_OFFICER_LABEL]: T.PAYROLL_OFFICER,
      };

      const role = roleMap[payload.employerRole];
      if (!role) return;

      // Derive the company id to attach to the invited employer
      const companyIdToUse = isCashDSuperAdmin
        ? searchInput?._id
        : selectedCompanyId;
      if (!companyIdToUse) return;

      dispatch(
        inviteEmployer({
        email: payload.email,
        firstName: payload.firstName,
        lastName: payload.lastName,
        role,
        company_id: companyIdToUse,
      })
      );
      resetForm();
      if (isCashDSuperAdmin) {
        setLocalState({
          searchInput: "",
          roleList: "",
        });
      } else {
        formik.setFieldValue(
          "companyName",
          selectedCompany?.company_name || ""
        );

        setLocalState({
          roleList: "",
        });
      }
      setIsModalOpen(false);
      dispatch(getEmployersList( INITIAL_PAGE, ROWS_PER_PAGE, selectedCompanyId))
    }
    
  });

  const onHandleClick = () => {
    formik.resetForm();

    if (!isCashDSuperAdmin) {
      formik.setFieldValue(
        "companyName",
        selectedCompany?.company_name || ""
      );
    }

    setLocalState({
      roleList: "",
    });

    setIsModalOpen(true);
  };
const handleModalClose = () => {
  formik.resetForm();

  if (isCashDSuperAdmin) {
    setLocalState({
      searchInput: "",
      roleList: "",
    });
  } else {
    formik.setFieldValue(
      "companyName",
      selectedCompany?.company_name || ""
    );

    setLocalState({
      roleList: "",
    });
  }

  setIsModalOpen(false);
};

  let debounceTimer: any = null;

  const handleOnChangeValue = async (searchText: string) => {
    clearTimeout(debounceTimer);

    if (searchText?.length >= 3) {
      debounceTimer = setTimeout(() => {
        dispatch(fetchCompanies(searchText));
      }, 500);
    }
  };
  const NO_COMPANY_SELECTED = {
    company_name: "",
  };

  const [localState, setLocalState] = useReducer(
    (prevState: any, newState: any) => ({ ...prevState, ...newState }),
    {
      searchInput: "",
      roleList: "",
      openAddEmployer: false,
      pageNumber: page,
      rowsPerPage: pageSize,
      isLoading: false,
    }
  );
  const { searchInput, rowsPerPage} = localState;

  const roleListItem: any[] = [
    { value: T.EMPLOYER_ADMIN, description: "Full access" },
    { value: T.EMPLOYER_USER, description: "View, payroll and invite employees" },
    { value: T.PAYROLL_OFFICER_LABEL, description: "View and payroll only" },
  ];

  const handleAutoCompleteChange = (type: string, newValue: any) => {
    if (newValue === null) {
      formik.setFieldValue("companyName", "");
      setLocalState({ [type]: NO_COMPANY_SELECTED });
    } else if (newValue) {
      console.log(newValue, "newValue");
      formik.setFieldValue("companyName", newValue.company_name);
      setLocalState({ [type]: newValue });
    }
  };

  const handleRoleChange = (name: string, value: string) => {
    formik.setFieldValue("employerRole", value);
    setLocalState({ [name]: value, selectedType: value });
  };

  const isHeaderReady = Boolean(companyName) && !isEmployersLoading;

  if (!selectedCompanyId) {
    return (
      <MainCard title={T.USERS}>
        <Alert color="warning" icon={<WarningFilled />}>
          Please select a company first
        </Alert>
      </MainCard>
    );
  }

  return (
    <MainCard
      title={isHeaderReady ? companyName : "-"}
      secondary={
        isHeaderReady && (isCashDSuperAdmin || isEmployerAdmin) ? (
          <Button variant={"outlined"} onClick={onHandleClick}>
            {T.Add_USER}
          </Button>
        ) : null
      }
    >
      <Grid container spacing={4}>
        <Grid item xs={12} sx={{ height: "100%" }}>
          <Typography align="left" className="table-heading">
            {T.USERS}
          </Typography>
          <Card variant="outlined" className="view-card-height">
            <CardContent>
              <Box>
                <ViewEmployerList 
                employers={employers}
                page={page}
                pageSize={pageSize}
                totalRecords={totalRecords}
                totalPages={totalPages}
                open={open}
                anchorEl={anchorEl}
                handleClick={handleClick}
                handleClose={handleClose}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
                />
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <CashDDialog open={isModalOpen} handleClose={handleModalClose} maxWidth="xs" fullWidth>
          <Box sx={{p: 2}}>
            <form onSubmit={formik.handleSubmit}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  pb: 2.5,
                  borderBottom: "1px solid",
                  borderColor: "divider",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Box
                    sx={{
                      width: 44,
                      height: 44,
                      borderRadius: 2,
                      bgcolor: "primary.lighter",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography fontSize={22}>👤</Typography>
                  </Box>
                  <Box>
                    <Typography variant="h5" fontWeight={600}>
                      {T.Add_USER}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Send an invitation to join the platform
                    </Typography>
                  </Box>
                </Box>
                <IconButton size="medium" onClick={handleModalClose}>
                  ✕
                </IconButton>
              </Box>
              <Stack spacing={3} sx={{ py: 3 }}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      name="firstName"
                      fullWidth
                      label="First Name"
                      value={formik.values.firstName}
                      onChange={formik.handleChange}
                      error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                      helperText={formik.touched.firstName && formik.errors.firstName}
                      InputProps={{ sx: { fontSize: "1rem" } }}
                      InputLabelProps={{ sx: { fontSize: "1rem" } }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      name="lastName"
                      fullWidth
                      label="Last Name"
                      value={formik.values.lastName}
                      onChange={formik.handleChange}
                      error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                      helperText={formik.touched.lastName && formik.errors.lastName}
                      InputProps={{ sx: { fontSize: "1rem" } }}
                      InputLabelProps={{ sx: { fontSize: "1rem" } }}
                    />
                  </Grid>
                </Grid>
                <TextField
                  name="email"
                  fullWidth
                  label="Email Address"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                  InputProps={{ sx: { fontSize: "1rem" } }}
                  InputLabelProps={{ sx: { fontSize: "1rem" } }}
                />
                <Box>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    fontWeight={600}
                    sx={{ mb: 1, textTransform: "uppercase", letterSpacing: "0.05em", fontSize: "0.75rem" }}
                  >
                    Company
                  </Typography>
                {isCashDSuperAdmin ? (
                  <CashDAutocomplete
                    placeholder={T.ALL_COMPANIES}
                    handleOnChangeValue={(e: any) => handleOnChangeValue(e.target.value)}
                    listDetails={orderBy(companiesList, ["company_name"], ["asc"])}
                    value={searchInput}
                    getByLabelText={(option: any) => get(option, "company_name", "")}
                    onHandleChange={(event: any, newValue: any) =>
                      handleAutoCompleteChange("searchInput", newValue)
                    }
                    isOptionEqualToValue={(option: any, value: any) => option._id === value._id}
                    helperText={formik.touched.companyName && formik.errors.companyName}
                    error={formik.touched.companyName && Boolean(formik.errors.companyName)}
                  />
                ) : (
                  <Typography variant="h6" fontWeight={600}>{companyName || "-"}</Typography>
                )}
                </Box>
                <Box>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    fontWeight={600}
                    sx={{ mb: 1.5, textTransform: "uppercase", letterSpacing: "0.05em", fontSize: "0.75rem" }}
                  >
                    Role
                  </Typography>
                  <Grid container spacing={2}>
                    {roleListItem.map((roleObj: any) => {
                      const role = roleObj.value;
                      const isSelected = formik.values.employerRole === role;
                      return (
                        <Grid item xs={12} sm={4} key={role}>
                          <Box
                            onClick={() => {
                              handleRoleChange("roleList", role);
                            }}
                            sx={{
                              border: isSelected ? "2px solid" : "1px solid",
                              borderColor: isSelected ? "primary.main" : "divider",
                              borderRadius: 2,
                              p: 2,
                              cursor: "pointer",
                              bgcolor: isSelected ? "primary.lighter" : "background.paper",
                              opacity: 1,
                              transition: "all 0.15s",
                              "&:hover": { borderColor: "primary.main", bgcolor: "primary.lighter" },
                            }}
                          >
                            <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                              <Typography variant="body1" fontWeight={600}>
                                {role}
                              </Typography>
                            </Stack>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                              {roleObj.description}
                            </Typography>
                          </Box>
                        </Grid>
                      );
                    })}
                  </Grid>
                  {formik.touched.employerRole && formik.errors.employerRole && (
                    <Typography variant="caption" color="error" sx={{ mt: 1, display: "block" }}>
                      {formik.errors.employerRole}
                    </Typography>
                  )}
                </Box>
              </Stack>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 2,
                  pt: 2.5,
                  borderTop: "1px solid",
                  borderColor: "divider",
                }}
              >
                <Button
                  color="secondary"
                  size="large"
                  onClick={handleModalClose}
                  sx={{ fontSize: "1rem", px: 3 }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  size="large"
                  sx={{ fontSize: "1rem", px: 4 }}
                >
                  Add
                </Button>
              </Box>
            </form>
          </Box>
        </CashDDialog>
      </Grid>
    </MainCard>
  );
};

export default React.memo(ViewGroupSetting);
